import React, { useState } from "react";
import { Form, Input, notification } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Homepage = () => {
  const [form] = Form.useForm();
  const [phoneCountry, setPhoneCountry] = useState("ae");
  const [whatsappCountry, setWhatsappCountry] = useState("ae");

  // EMAIL VALIDATION
  const validateEmail = (_, value) => {
    if (!value) {
      return Promise.reject("Please enter your email address");
    }

    if (value.includes(" ")) {
      return Promise.reject("Email must not contain spaces");
    }

    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(value)) {
      return Promise.reject("Please enter a valid email address");
    }

    return Promise.resolve();
  };

  // PHONE VALIDATION
  const validatePhone = (_, value) => {
    if (!value) {
      return Promise.reject("Please enter phone number");
    }

    if (phoneCountry === "ae") {
      const digits = value.replace(/\D/g, "");

      if (!digits.startsWith("971")) {
        return Promise.reject("UAE numbers must start with +971");
      }

      const localNumber = digits.slice(3);
      if (localNumber.length !== 9) {
        return Promise.reject("Enter a valid 9-digit UAE phone number");
      }
    }

    return Promise.resolve();
  };

  // WHATSAPP VALIDATION
  const validateWhatsapp = (_, value) => {
    if (!value) return Promise.resolve();

    if (whatsappCountry === "ae") {
      const digits = value.replace(/\D/g, "");

      if (!digits.startsWith("971")) {
        return Promise.reject("UAE WhatsApp number must start with +971");
      }

      const localNumber = digits.slice(3);
      if (localNumber.length !== 9) {
        return Promise.reject("Enter a valid 9-digit UAE WhatsApp number");
      }
    }

    return Promise.resolve();
  };

  // SUBMIT HANDLER
  const onFinish = async (values) => {
    const payload = {
      name: values.name,
      email: values.email,
      phoneNumber: `+${values.phone}`,
      whatsappNumber: values.whatsapp ? `+${values.whatsapp}` : "",
      eventType: "Dubai Property Investment Expo Webinar",
    };

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbz-EFsWePzYMYWuO56AUTnsuEnkTw0cXg8oRrq6DTMfAuHAh-wA0Bom-6H5wn4HfZEIBQ/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      notification.success({
        message: "Form Submitted",
        description: "✅ Thank you! Your form has been submitted successfully.",
      });

      form.resetFields();
    } catch {
      notification.error({
        message: "Submission Error",
        description: "Unable to submit the form at this time.",
      });
    }
  };

  return (
    <section className="min-h-screen bg-[#fffaf0] flex items-center px-4 py-12">
      <div className="max-w-7xl mx-auto w-full shadow-md bg-white">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center">

          {/* IMAGE */}
          <div className="flex justify-center">
            <img
              src={require("../../assets/images/webinar.png")}
              alt="Webinar"
              className="w-full object-contain"
            />
          </div>

          {/* FORM */}
          <div className="p-6 lg:p-10 flex flex-col items-center">
            <p className="mb-6 text-center font-semibold text-gray-700">
              Join The Exclusive Webinar — Fill The Form Below
            </p>

            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              validateTrigger="onSubmit"
              className="w-full space-y-4"
            >
              <Form.Item
                label="Full Name"
                name="name"
                rules={[{ required: true, message: "Please enter your full name" }]}
              >
                <Input placeholder="Enter your full name" />
              </Form.Item>

              <Form.Item
                label="Email Address"
                name="email"
                rules={[{ validator: validateEmail }]}
              >
                <Input placeholder="Enter your email address" />
              </Form.Item>

              <Form.Item
                label="Phone Number"
                name="phone"
                rules={[{ validator: validatePhone }]}
                required
              >
                <PhoneInput
                  country="ae"
                  enableSearch
                  onChange={(value, country) => {
                    setPhoneCountry(country.countryCode);
                    form.setFieldValue("phone", value);
                  }}
                  inputClass="w-full border-gray-300 focus:ring-1 focus:ring-[#142a13]"
                />
              </Form.Item>

              <Form.Item
                label="WhatsApp Number"
                name="whatsapp"
                rules={[{ validator: validateWhatsapp }]}
              >
                <PhoneInput
                  country="ae"
                  enableSearch
                  onChange={(value, country) => {
                    setWhatsappCountry(country.countryCode);
                    form.setFieldValue("whatsapp", value);
                  }}
                  inputClass="w-full border-gray-300 focus:ring-1 focus:ring-[#142a13]"
                />
              </Form.Item>

              <Form.Item>
                <button type="submit" className="cssbuttons-io-button w-full mt-3">
                  RESERVE YOUR SLOT
                </button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Homepage;
